import React,  { useRef } from "react";
import headerImage from "../../assets/header4.jpg";
import w6_1 from "../../assets/w6-1.jpg";
import w6_2 from "../../assets/w6-2.jpg";
import w6_3 from "../../assets/w6-3.jpg";
import w6_4 from "../../assets/w6-4.jpg";
import w6_7 from "../../assets/w6-7.jpg";
import w6_8 from "../../assets/w6-8.jpg";
import w6_10 from "../../assets/w6-10.jpg";
import w6_11 from "../../assets/w6-11.jpg";
import w6_12 from "../../assets/w6-12.jpg";
import w6_13 from "../../assets/w6-13.jpg";
import w6_14 from "../../assets/w6-14.jpg";
import w6_15 from "../../assets/w6-15.jpg";
import w6_16 from "../../assets/w6-16.jpg";
import w6_17 from "../../assets/w6-17.jpg";
import w6_18 from "../../assets/w6-18.jpg";
import w6_19 from "../../assets/w6-19.jpg";
import w6_20 from "../../assets/w6-20.jpg";
import w6_21 from "../../assets/w6-21.jpg";
import w6_22 from "../../assets/w6-22.jpg";
import w6_23 from "../../assets/w6-23.jpg";
import w6_24 from "../../assets/w6-24.jpg";
import w6_25 from "../../assets/w6-25.jpg";
import w6_26 from "../../assets/w6-26.jpg";



const Assignment7 = () => {
  const hardware = useRef(null);
  const KiCad = useRef(null);
  const PCBEditor = useRef(null);

  const scrollToSection = (ref) => {
    ref.current?.scrollIntoView({ behavior: "smooth" });
  };


    
  return (

    <div className="container mx-auto my-8 px-5 max-w-3xl bg-gray-100 p-8 rounded-lg shadow-md">
      {/* Header */}
      <div className="relative mb-8">
        <img
          src={headerImage}
          alt="Header"
          className="w-full h-64 object-cover rounded-lg shadow-md  object-cover filter grayscale brightness-75"
        />
        <div className="absolute bottom-0 left-0 right-0 bg-gradient-to-t from-black to-transparent p-4 rounded-b-lg">
          <h1 className="text-4xl font-bold text-bg-secondary"  style={{ textShadow: '2px 2px 4px rgba(0, 0, 0, 1)' }}>6. Week - Electronic Design </h1>
          <p className="text-gray-300 mt-2">Published on: <span className="font-semibold">March 11, 2025</span></p>
          <div className="mt-4 flex space-x-4">
         {/* Navigation Links */}
      <div className="mt-4 flex space-x-4">
        <button onClick={() => scrollToSection(hardware)} className="text-white bg-secondary px-3 py-1 rounded hover:bg-secondary">
         Hardware Design
        </button>
        <button onClick={() => scrollToSection(KiCad)} className="text-white bg-secondary px-3 py-1 rounded hover:bg-secondary">
          KiCad
        </button>
        <button onClick={() => scrollToSection(PCBEditor)} className="text-white bg-secondary px-3 py-1 rounded hover:bg-secondary">
          PCB Editor
        </button>

        </div>
        </div>
        </div>
        </div>
        <p className="text-justify text-gray-700 mb-6">
        This week was all about PCB design!

To start off, I decided to dive into some recommended reading: the         <a 
          href="https://datasheets.raspberrypi.com/rp2040/hardware-design-with-rp2040.pdf" 
          className="text-blue-500 underline"
          target="_blank"
          rel="noopener noreferrer"
        >
          RP2040 Hardware Design Guide
        </a>. Before going through this document, I wasn’t entirely sure which components were essential for designing my first custom development board. However, this guide provided valuable insights, helping me understand the importance of different components and their connections.
      </p>
      <p className="text-justify text-gray-700 mb-6">
        As always you will find our group assignment on our
        <a 
          href="https://fabacademy.org/2025/labs/bottrop/Assignments/week06/" 
          className="text-blue-500 underline ml-1" 
          target="_blank" 
          rel="noopener noreferrer"
        >
          group documentation page
        </a>.
      </p>

        {/* Hardware Design Section*/}
        <div ref={hardware}></div>
        <h2 className="text-3xl font-bold text-left mb-6">Hardware Design</h2>


      <p className="text-justify text-gray-700 mb-6">
      One of the most helpful aspects of the guide was the minimal design example, which served as a great starting point for my own project. The fundamental components required for a basic RP2040 board include:
      </p>

      <h3 className="text-xl font-semibold mt-6">Minimal RP2040 Design Example</h3>
      <ul className="list-disc list-inside space-y-2">
        <li><strong>Micro USB Connector</strong> – Provides <em>5V power input</em>.</li>
        <li><strong>Decoupling Capacitors</strong> – Help filter out power supply noise and prevent voltage drops during rapid current demand changes</li>
        <li><strong>Voltage Regulator</strong> – Requires 1μF capacitors near both the VREG_IN and VREG_OUT pins to ensure a stable 1.1V power supply</li>
        <li><strong>Flash Storage</strong> – Stores the <em>program code</em>.</li>
        <li><strong>12MHz Crystal Oscillator</strong> – While the RP2040 has an internal oscillator, it is recommended to use an external crystal oscillator for precise frequency stability. Factors such as temperature changes can cause the internal oscillator’s frequency to fluctuate, making USB applications and other time-sensitive tasks unreliable.</li>
        <li><strong>I/O Pins</strong> – For <em>connecting external peripherals</em>.</li>
        <li><strong>USB stabilization</strong></li>
        <li><strong>I/O headers</strong></li>

      </ul>

      <h3 className="text-xl font-semibold mt-6">Alternative: XIAO Seeed ESP32</h3>
      <p>
      Instead of designing a PCB completely from scratch, I explored existing RP2040-based and ESP32 alternatives and found the Seeed Studio XIAO ESP32 to be a great option that is allowed to use by fabacademy.{" "}
      Thanks to 
        <a 
          href="http://fabacademy.org/2020/labs/leon/students/adrian-torres/fabxiao.html" 
          className="text-blue-500 underline"
          target="_blank"
          rel="noopener noreferrer"
        >
Adrian Torres’ FabXIAO documentation
        </a>, I decided to take a simplified approach for my first PCB, focusing on adapting an existing design rather than starting from zero with a dual layer PCB.
      </p>
      <img src={w6_1} alt="" className="my-4 mx-auto rounded shadow-md" />
      <img src={w6_7} alt="" className="my-4 mx-auto rounded shadow-md" />
{/* KiCad Section*/}
<div ref={KiCad}></div>
        <h2 className="text-3xl font-bold text-left mb-6">Creating a circuit board with KiCad</h2>
        <p className="text-justify text-gray-700 mb-6">
        Creating a circuit board with KiCad involves designing the schematic, defining the board layout, and preparing the files for fabrication.

      </p>
      <p className="text-justify text-gray-700 mb-6">
        
<img src={w6_23} alt="" className="my-4 mx-auto rounded shadow-md" />

      This image shows the KiCad start interface, where I began by creating a new project. From here, I accessed the schematic editor to design the circuit and later used the PCB editor to layout the board. This step marks the beginning of the PCB design process in KiCad.
      </p>
      <h3 className="text-xl font-semibold mt-6">Importing Libraries in KiCad</h3>
      <p>To use the XIAO modules, I imported the required KiCad libraries from:</p>
      <a 
        href="https://github.com/Seeed-Studio/OPL_Kicad_Library" 
        className="text-blue-500 underline"
        target="_blank"
        rel="noopener noreferrer"
      >
        Seeed Studio KiCad Library
      </a>
      <img src={w6_4} alt="" className="my-4 mx-auto rounded shadow-md" />
      You can also find foodprints at digikey or snap magic and import them to your project. It is important, that you add them as symbol and foodprint library. 
      <img src={w6_8} alt="" className="my-4 mx-auto rounded shadow-md" />


      <h3 className="text-xl font-semibold mt-6">Editing the schematic file</h3>

      <p className="text-justify text-gray-700 mb-6">
      Press a to open the symbol library. Search for ESP32 - I selected the ESP32S3 from XIAO because that's the microcontroller I would like to use in my final project.
      </p>
      <img src={w6_24} alt="" className="my-4 mx-auto rounded shadow-md" />
      <img src={w6_25} alt="" className="my-4 mx-auto rounded shadow-md" />
      <p className="text-justify text-gray-700 mb-6">I searched for the required components in the KiCad library and added them one by one to the schematic editor, ensuring that all necessary parts for the circuit were included.</p>
      In my case, I added only the essential components to the schematic editor: the microcontroller, three pin headers, an LED, and a resistor.
      Next, I added the power sources and used the "Draw Wires" function to connect the components, ensuring proper electrical connections in the schematic.
   


        <img src={w6_11} alt="" className="my-4 mx-auto rounded shadow-md" />
        The finalized schematic, with all components and connections in place, is shown below.
        <img src={w6_26} alt="" className="my-4 mx-auto rounded shadow-md" />

{/* PCB Editor Section*/}

        <div ref={PCBEditor}></div>
        <h3 className="text-xl font-semibold mt-6">PCB Editor and Routing</h3>
        Next, I switched to the PCB Editor to begin the layout process. All components from the schematic were imported, and I started arranging them on the board to optimize the placement for routing the connections efficiently.
        
        <img src={w6_12} alt="" className="my-4 mx-auto rounded shadow-md" />
        I defined the PCB outline by drawing a rectangular boundary around the components using specific dimensions. This outline represents the final shape and size of the board, ensuring all components fit within the designated area.

        <img src={w6_13} alt="" className="my-4 mx-auto rounded shadow-md" />
        The 'Draw Filled Zones' function in KiCad allows the creation of copper pours, which are used to fill large areas of the PCB with a conductive material. This is commonly used for ground (GND) or power (VCC) planes, improving electrical performance and simplifying routing by reducing the need for multiple traces.
        <img src={w6_14} alt="" className="my-4 mx-auto rounded shadow-md" />

        <p className="text-justify text-gray-700 mb-6"> 
        The Copper Zone Properties window in KiCad is used to configure and define copper pour areas on a PCB. The Layer Selection allows the user to choose on which PCB layer the copper zone should be applied, such as F.Cu for the top copper layer or B.Cu for the bottom layer. The Net Assignment section specifies which electrical net the copper zone should connect to, such as GND for ground or VCC for power. If "no net" is selected, the copper zone will be isolated and not connected to any circuit.

        </p>
        <p className="text-justify text-gray-700 mb-6"> 
        In the General Settings, the user can optionally name the copper zone and set its priority level, which determines how overlapping zones interact. The Shape and Display settings include options for outline display, such as a hatched or solid representation, and allow for corner smoothing to round off sharp edges.
        </p>
        <p className="text-justify text-gray-700 mb-6"> 
        The Electrical Properties define important design parameters such as clearance, which sets the minimum distance between the copper pour and other components, and minimum width, which determines the smallest copper trace width within the zone. In the Pad Connections section, thermal reliefs can be enabled to ensure pads are not directly connected to large copper areas, which aids in solderability by preventing excessive heat dissipation. Parameters such as thermal relief gap and spoke width fine-tune these connections.
        </p>
        <p className="text-justify text-gray-700 mb-6"> 
        Lastly, the Fill Options allow users to choose between a solid fill or a hatched pattern. The smoothing effort and amount control how smooth the edges appear, and the remove islands setting helps eliminate small, unconnected copper sections that could cause unwanted electrical behavior. These settings ensure that the copper zones are properly connected and optimized for both electrical performance and manufacturability.
        </p>

        <img src={w6_15} alt="" className="my-4 mx-auto rounded shadow-md" />
        <p className="text-justify text-gray-700 mb-6">  I used the "Draw Filled Zones" function to create a copper pour, which helps optimize electrical performance and reduce interference. I assigned the appropriate net to this zone to connect ground traces.</p>
        <img src={w6_17} alt="" className="my-4 mx-auto rounded shadow-md" />

        <p className="text-justify text-gray-700 mb-6">I then configured the copper zone properties, adjusting parameters such as clearance and fill type. </p>
        <img src={w6_18} alt="" className="my-4 mx-auto rounded shadow-md" />
        <p className="text-justify text-gray-700 mb-6"> After defining the copper pour, I filled the board with copper planes and confirmed that all necessary connections were made.</p>
        <img src={w6_19} alt="" className="my-4 mx-auto rounded shadow-md" />
        <p className="text-justify text-gray-700 mb-6">I then routed the necessary traces, ensuring proper connectivity between all components. Each trace follows the designated net, maintaining signal integrity while avoiding unnecessary overlaps. </p>
        <img src={w6_20} alt="" className="my-4 mx-auto rounded shadow-md" />
        <p className="text-justify text-gray-700 mb-6">Additionally, I placed vias to connect the ground planes on both layers of the PCB, ensuring a continuous and stable ground connection. This step helps reduce electromagnetic interference and improves overall circuit performance. </p>
        <img src={w6_21} alt="" className="my-4 mx-auto rounded shadow-md" />
        <p className="text-justify text-gray-700 mb-6">To verify the design, I used the 3D viewer to check the final PCB layout. This visualization helps in identifying any placement issues and ensures that all components fit correctly on the board.</p>
        <img src={w6_22} alt="" className="my-4 mx-auto rounded shadow-md" />


        <a
    style={{display: "block" }}
    href="https://fabacademy.org/2025/labs/bottrop/students/annasophia-brokuf/files/ESP32_PCB_KiCad_Files.zip"
    download
  >
    📎 Download KiCad Files
  </a>
            </div>
                


  );
};

export default Assignment7;
